import { Security } from '@blk/awt-aladdinportfoliobuilderserver';

export enum Identifiers {
  ALADDIN_ID = 'aladdinId',
  CLIENT_ID = 'clientId',
  CUSIP = 'cusip',
  ISIN = 'isin',
  MORNINGSTAR_SEC_ID = 'morningstarSecId',
  PUBLIC_CUSIP = 'publicCusip',
  RIC = 'ric',
  SEDOL = 'sedol',
  TICKER = 'ticker',
  VALOR = 'valoren',
  WKN = 'wkn',
}
export interface IdentifiersMap {
  [Identifiers.ALADDIN_ID]?: string;
  [Identifiers.CLIENT_ID]?: string;
  [Identifiers.CUSIP]?: string;
  [Identifiers.ISIN]?: string;
  [Identifiers.MORNINGSTAR_SEC_ID]?: string;
  [Identifiers.PUBLIC_CUSIP]?: string;
  [Identifiers.RIC]?: string;
  [Identifiers.SEDOL]?: string;
  [Identifiers.TICKER]?: string;
  [Identifiers.VALOR]?: string;
  [Identifiers.WKN]?: string;
}
export interface ResolvableSecurity {
  identifiers: IdentifiersMap;
}

export interface ResolvableSecurityRequest {
  resolvableSecurities: { [key: string]: ResolvableSecurity };
}

export interface ResolvableSecurityResponse {
  resolvedSecurities: { [key: string]: Security };
  unresolvedSecurities: { [key: string]: ResolvableSecurity };
}
